<script setup>
import Navbar from '@/components/NavbarView.vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { Files, HelpFilled, Setting } from '@element-plus/icons-vue';

const route = useRoute()
console.log('route:', route)
const onRoutes = computed(() => {
  return route.path
})

const router = useRouter();
console.log('当前路由:', router.currentRoute.value.meta.title)
console.log('router:', router)
const back = () => {
  console.log('首页')
  router.push({ name: 'notice' })
}


</script>

<template>
  <div>
    <Navbar :showMenu="false" />
    <!-- <el-page-header style="margin-top: 10px;"
        icontext="返回" title="首页" subtitle="" @back="back"/> -->
        
    <!-- <div class="header">
      <el-page-header @back="back" title="首页" style="margin-top: 8px;">
        <template #content>
          <span style="font-size: 15px;"> 
            {{ router.currentRoute.value.meta.title }} 
            {{ $route.meta.title }}
          </span>
        </template>
      </el-page-header>
    </div> -->
    <el-row class="tac">
      <el-col :span="3" style="margin-top: 60px;padding-top: 10px;">
        <el-menu router :default-active="onRoutes">
          <!-- <el-menu-item index="/upload">
            <el-icon><Upload /></el-icon>
            <span>上传作品</span>
          </el-menu-item> -->
          <el-menu-item index="/my-work-list">
            <el-icon><Files /></el-icon>
            <span>我的参赛作品</span>
          </el-menu-item>
          <el-menu-item index="/my-topic-list">
            <el-icon><Files /></el-icon>
            <span>我的科创选题</span>
          </el-menu-item>
          <!-- <el-menu-item index="/my-work-status">
             <el-icon><HelpFilled /></el-icon>
            <span>查看作品状态</span>
          </el-menu-item> -->
          <el-menu-item index="/stu-setting">
            <el-icon><Setting /></el-icon>
            <span>设置</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="21">
        <div class="content-box">
          <router-view />
        </div>
        <!-- <router-view /> -->
      </el-col>
    </el-row>
  </div>
</template>


<style scoped>
.header{
  background: #fff;
  border-bottom: 1px solid #f2eeee;
  padding-bottom: 5px;
}
</style>